export const HOMEPAGE_BUCKET_LINK = `https://daymade-website-assets.s3.eu-west-1.amazonaws.com/2026/homepage`;
